(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-check', {
                parent: 'entity',
                url: '/type-check',
                data: {
                    authorities: [],
                    pageTitle: 'TypeChecks'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-check/list/type-check.html',
                        controller: 'TypeCheckController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK, access);
                }]
            });
    }
})();
